<sl-input *ngIf="!filePresent"
          ngDefaultControl
          [name]="key"
          [label]="props.label | htmlDecode"
          type="file"
          [disabled]="props.disabled || false"
          [required]="props.required || false"
          [shoelaceReadonly]="props.readonly"
          (click)="handleClick($event)"
          (input)="uploadFile($event)"
          [placeholder]="props.placeholder"
>

</sl-input>

<p class="label-uploaded-file" *ngIf="filePresent">{{ props.label | htmlDecode }} <span class="required-color" *ngIf="props.required">*</span></p>
<sl-card *ngIf="filePresent" class="sl-card-file-field" [shoelaceReadonly]="props.readonly">
    <div class="file-uploaded-options">
        <a [href]="'/form/submitFileUpload/' + fileIdForDownload + '/' + fileEntry.value" target="_blank">
            {{ fileEntry.value }}
        </a>
        <sl-icon-button name="trash" label="Delete" (click)="deleteFile()"></sl-icon-button>
    </div>
</sl-card>
